import type { IconSvgObject } from './types';

const FlaskRoundIcon: IconSvgObject = [
  ["path", { d: "M5.5 13.3247C6.25954 13.1279 7.07646 13 8 13C11 13 14 16 17 16C17.5754 16 18.0713 15.947 18.5 15.8557", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 2H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.5 2V8.45963C6.86863 9.46605 5 12.0148 5 15C5 18.866 8.13401 22 12 22C15.866 22 19 18.866 19 15C19 12.0148 17.1314 9.46605 14.5 8.45963V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FlaskRoundIcon;
